import isDevelopment from './isDevelopment';

export default function baseUrl() {
	let transporterCode = localStorage.getItem('transporterCode');
	let { hostname } = location;
	return isDevelopment() ? `http://${hostname}:5000/v1/${transporterCode}` : `https://api.${hostname}/v1/${transporterCode}`;
	// return 'https://api.staging.sight.timpex.cloud/v1/timsight';
}
